// @flow
import React, {PureComponent} from 'react';
import classNames from 'classnames';

type Props = {
    day: number,
    isPast: boolean,
    isToday: boolean
};

const clickable = ({isPast}: Props) => {
    return !isPast;
};

/**
 * Stripped down version of PDP day availability
 * https://github.homeawaycorp.com/traveler/react-trip-details/blob/master/src/components/calendarTemplates/DayAvailability/DayAvailability.js
 */
class DayAvailability extends PureComponent<Props> {
    static canClick = clickable;
    static canHover = clickable;

    render() {
        const {day, isPast} = this.props;
        const dateClasses = classNames({
            date: true,
            today: false,
            past: isPast
        });

        return <div className={dateClasses}>{day}</div>;
    }
}

export default DayAvailability;
